import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { FlatpickrOptions } from 'angularx-flatpickr';
import flatpickr from 'flatpickr';
import { Router } from '@angular/router';
import { GlobalvaribleService } from 'src/app/services/globalvarible.service';
// import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
// import {  DateAdapter } from '@angular/material/core';
import { DvmpService } from 'src/app/shared/services/dvmp.service';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../shared/date-picker-format';
import * as momenttz from 'moment-timezone';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css'],
  providers: [
    {
      provide: DateAdapter, useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})
export class PatientComponent implements OnInit, AfterViewInit, OnChanges {

  treatment = environment.treatment_date;
  mydata = {};
  patientdata = {};
  patientConfiguration: FormGroup;
  submitted = false;
  formvalidated = false;
  loading = true;
  d: Date;
  _buttonValue: boolean;
  isreadonly = false;
  _buttontext: string;
  disbalecalendar = true;
  serializedDate;
  fechaactualmodal: string;
  _elementRef: string;
  _firstFlag: boolean;
  flagcheck: any = false;
  _errorflag = false;
  show = false;
  _termsconditionFlag = false;
  treatmentfullname = '';
  FechaactualDate: any;
  termsEx: any = $localize`:@@termsSec2:terms`;
  localholidays: Array<any> = [];
  treatStartDate = $localize`:@@treatStartDate:treatStartDate`.replace(':', '');
  constructor(public _dvmp: DvmpService, private formbuilder: FormBuilder, private modalService: NgbModal, private router: Router,
    public _globalvarible: GlobalvaribleService, public dateadapter: DateAdapter<any>) {
    this._dvmp.locale_code = environment.locale;
  }
  ngOnInit() {
    console.log('patient file build');
    this.dateadapter.getFirstDayOfWeek = () => 1;
    this.fechaactualmodal = moment(new Date()).format('DD/MM/YY');
    localStorage.removeItem('patientdetails');
    localStorage.removeItem('DeafultValues');
    localStorage.removeItem('startDateChanged');
    this._buttonValue = true;
    const flag = this._globalvarible.getlegaldisclamer();
    const value = localStorage.getItem('flag');
    if (value == null) {
      const modal = document.getElementById('legalDisclaimer');
      modal.style.display = 'block';
    }
    this.patientConfiguration = this.formbuilder.group({
      // Wieght: [, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(30), Validators.max(200)]],
      // Hieght: [, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(100), Validators.max(250)]],
      Tratamientos: [, Validators.required],
      Cicle: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
      Fechaactual: [new Date(), Validators.required],
      Nocicle: [6, [Validators.required, Validators.min(1), Validators.max(12)]],
      observations: [, Validators.maxLength(1000)],
      Formulation: [, ],
    });
    this._dvmp.getDvmp(this._dvmp.locale_code).subscribe(res => {
      this._dvmp.country = res.countryCode;
      this._dvmp.optedTreatments = res.optedTreatments;
      this._dvmp.formulation = res.formulation;
      this._dvmp.language = res.language;
      this._dvmp.calLangCode = res.calendarLanguageCode;
      this._dvmp.enableInputTextboxes = res.enableInputTextboxes;
      this._dvmp.SMPCDefintionDropdowns = res.SMPCDefintionDropdowns;
      this._dvmp.DragnDropWithPopup = res.DragnDropWithPopup;
      if (res.formulation) {
        this.patientConfiguration.get('Formulation').setValidators([Validators.required]);
      } else {
        this.patientConfiguration.get('Formulation').clearValidators();
      }
      this.patientConfiguration.get('Formulation').updateValueAndValidity();
    });
    const spain = require('flatpickr/dist/l10n/es.js').default.es;
    flatpickr.localize(spain);
  }

  /**
   * Prevent Saturday and Sunday from being selected in the date picker.
   */
  myFilter = (d: Date): boolean => {
    const day = d.getDay();
    return day !== 0 && day !== 6;
  }

  /*change the event start here*/
  /*change the event end here*/

  ngAfterViewInit() {
    /*setTimeout(() => {
      this.modalService.open(NgbdModalContent);
    });*/
  }
  newPatient() {
    this.router.navigateByUrl('/');
  }

  /* scroll event start here*/
  scrollHandler(event) {
    // var event;

  }
  /* scroll event end here*/


  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {

    }
  }
  get f() { return this.patientConfiguration.controls; }
  get Tratamientos() {
    return this.patientConfiguration.get('Tratamientos');
  }
  get Formulation() {
    return this.patientConfiguration.get('Formulation');
  }
  clickEvent($event) {
    this._buttonValue = !this._buttonValue;

    if (this._buttonValue) {
      this.patientConfiguration.controls['Tratamientos'].enable();
      this.patientConfiguration.controls['Fechaactual'].enable();
      // this.disbalecalendar = !this.disbalecalendar;
      // console.log(this.disbalecalendar);
    }

  }

  // terms condiiton click
  termsconditionclick() {
    const flaglocal = localStorage.getItem('flag');
    this._termsconditionFlag = (flaglocal === 'true');
    const modal = document.getElementById('legalDisclaimer');
    modal.style.display = 'block';
    document.getElementById('legalDisclaimerBody').scrollTop = 0;
  }
  // end terms condiiton click


  // next btn
  public nextClick() {
    if (!this.flagcheck) {
      this._errorflag = true;
    } else {
      this._errorflag = false;
      const flaglocal = localStorage.getItem('flag');
      this._termsconditionFlag = (flaglocal === 'true');
      const modal = document.getElementById('legalDisclaimer');
      localStorage.setItem('flag', 'true');
      modal.style.display = 'none';
    }
  }

  public Reset() {
    this.patientConfiguration.reset('Tratamientos');
    this.patientConfiguration.reset('Formulation');
    this.patientConfiguration.patchValue({ Nocicle: 6, Cicle: 1, Fechaactual: new Date() });
    // this.router.navigate(['/home']);
  }
  close() {
    const modal = document.getElementById('legalDisclaimer');
    modal.style.display = 'none';
  }
  onSubmit() {
    //   if (localStorage.getItem("holidays") !== undefined) {
    //     this.localholidays = JSON.parse(localStorage.getItem("holidays"));
    //   }
    //  console.log(this.localholidays,'this.localholidays')
    localStorage.clear();
    localStorage.setItem('patientdetails', '');
    if (this.patientConfiguration.valid) {

      this.isreadonly = !this.isreadonly;
      this.patientdata = this.patientConfiguration.value;
      // console.log(this.patientdata);
      // console.log(JSON.stringify(this.patientdata));

      localStorage.setItem('testdate', momenttz(this.patientdata['Fechaactual'], 'YYYY-DD-MM', true) + '');



      const spiteddates = new Date(this.patientConfiguration.value.Fechaactual).toLocaleDateString().split('/');
      const genratedvalue = spiteddates[1] + '/' + spiteddates[0] + '/' + spiteddates[2];
      this.patientConfiguration.value.Fechadisplay = genratedvalue;

      localStorage.setItem('patientdetails', JSON.stringify(this.patientdata));
      localStorage.setItem('flag', 'true');
      this.formvalidated = true;
      console.log('checking for holidays');
      this._dvmp.seeCal();
      // if (this.localholidays) {
      //   localStorage.setItem("holidays", JSON.stringify(this.localholidays));
      // }

    }
    this.submitted = true;

  }

  eventHandler(event) {
    if (event && event.trim()) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
  onChange($event) {
    this.fechaactualmodal = moment($event.target.value).format('DD/MM/YY');

  }

}
